import apiEndpoints from '@src/lib/apiEndpoints';
import { TableData } from '@src/lib/types';

import apiRequest from './api';

export interface Organization {
  id?: string;
  name: string;
  email: string;
  org_name: string;
  phoneNumber?: string;
  logo?: {
    filename: string;
    pdfKey: string;
  };
}

export const createOrganization = (data: TableData) => {
  return apiRequest({
    method: 'POST',
    url: `${apiEndpoints.ORGANIZATION}`,
    data,
  });
};

export const updateOrganization = (data: TableData, id: string) => {
  return apiRequest({
    method: 'PUT',
    url: `${apiEndpoints.ORGANIZATION}/${id}`,
    data,
  });
};

export const getOrganizations = (params?: TableData) => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.ORGANIZATION}`,
    config: { params },
  });
};

export const getOrganizationById = (id: string) => {
  return apiRequest({
    method: 'GET',
    url: `${apiEndpoints.ORGANIZATION}/${id}`,
  });
};

export const deleteOrganization = (id: string) => {
  return apiRequest({
    method: 'DELETE',
    url: `${apiEndpoints.ORGANIZATION}/${id}`,
  });
};
